export const DataInputMobileSidePadding = 24;
export const bottomNavigationMenuHeight = 75;
